import { defineStore } from 'pinia';
import QuoteFeatureService from '@/service/QuoteFeatureService';

export const useViewRuleStore = defineStore('viewRuleStore', {
  actions: {
    async getLogRule(id) {
      const quoteFeatureService = new QuoteFeatureService();
      const res = await quoteFeatureService.viewLogRule(id);
      return res?.data;
    },
    async updateFlightRule(id, option) {
      const quoteFeatureService = new QuoteFeatureService();
      const res = await quoteFeatureService.updateFlightRule(id, option);
      return res?.data;
    },
    async updateHotelRule(id, option) {
      const quoteFeatureService = new QuoteFeatureService();
      const res = await quoteFeatureService.updateHotelRule(id, option);
      return res?.data;
    },
    async updateTourRule(id: string, mdtOption: number, tourOption: number) {
      const quoteFeatureService = new QuoteFeatureService();
      const res = await quoteFeatureService.updateTourRule(id, mdtOption, tourOption);
      return res?.data;
    },
    async updateFlightTourRule(id: string, mdtOption: number, tourOption: number) {
      const quoteFeatureService = new QuoteFeatureService();
      const res = await quoteFeatureService.updateFlightTourRule(id, mdtOption, tourOption);
      return res?.data;
    },
    async getTourLogRule(id: string) {
      const quoteFeatureService = new QuoteFeatureService();
      const res = await quoteFeatureService.viewTourLogRule(id);
      return res?.data;
    },
    async getRuleAssignment() {
      const Service = new QuoteFeatureService();
      const res = await Service.getRuleAssignment();
      return res?.data;
    },
    async updateRuleAssignment(payload: any) {
      const Service = new QuoteFeatureService();
      const res = await Service.updateRuleAssignment(payload);
      return res?.data;
    }
  }
});
